var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 205,
    viewBox: "0 0 279 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5906 27.0034C89.915 10.9605 106.678 0 126 0C147.275 0 165.447 13.288 172.669 32.0174C173.111 32.0058 173.555 32 174 32C190.463 32 205.067 39.9563 214.178 52.2335C218.861 50.7818 223.839 50 229 50C256.614 50 279 72.3858 279 100C279 127.614 256.614 150 229 150C227.232 150 225.486 149.908 223.766 149.729C217.466 166.338 202.571 178.718 184.513 181.439C184.829 182.087 185 182.78 185 183.5C185 187.09 180.747 190 175.5 190C170.253 190 166 187.09 166 183.5C166 182.595 166.27 181.733 166.759 180.95C156.279 178.769 147.002 173.307 140.05 165.686C132.464 170.326 123.544 173 114 173C97.6024 173 83.0484 165.107 73.9305 152.912C66.8229 156.794 58.6691 159 50 159C22.3858 159 0 136.614 0 109C0 87.2277 13.9159 68.7057 33.3385 61.8433C39.758 41.6387 58.6695 27 81 27C81.1971 27 81.394 27.0011 81.5906 27.0034ZM174.5 205C176.985 205 179 203.433 179 201.5C179 199.567 176.985 198 174.5 198C172.015 198 170 199.567 170 201.5C170 203.433 172.015 205 174.5 205Z",
    fill: "#FAFAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.0d60f0e3f9962aaa548e2c611abafc81.svg";
export { ForwardRef as ReactComponent };